class LocalTime extends HTMLElement {
    static observedAttributes: string[] = ['date', 'epoch', 'format'];
    private _dateObject: Date = new Date();

    constructor() {
      super();
    }

    attributeChangedCallback(attrName: string, oldValue: string, newValue: string) {
        if (newValue !== oldValue) {
            if (attrName === 'date') {
                this.date = newValue; // Explicitly call the setter
            } else if (attrName === 'epoch') {
                this.epoch = newValue; // Explicitly call the setter
            } else if (attrName === 'format') {
                this.format = newValue; // Explicitly call the setter
            }
        }
    }

    get epoch(): string {
        return this.getAttribute('epoch') || '';
    }

    set epoch(value: string) {
        this.setAttribute('epoch', value);
        this._dateObject = new Date(parseInt(value) * 1000);
        this._updateDate();
    }

    get date(): string {
        return this.getAttribute('date') || '';
    }

    set date(value: string) {
        this.setAttribute('date', value);
        this._dateObject = new Date(value);
        this._updateDate();
    }

    get format(): string {
        return this.getAttribute('format') || '';
    }

    set format(value: string) {
        this.setAttribute('format', value);
        this._updateDate();
    }

    private _updateDate(): void {
        let format = {}
        if (this.format == 'time12') {
            format = { hour: 'numeric', hour12: true, minute: 'numeric' }
        } else if (this.format == 'date') {
            format = { year: 'numeric', month: 'long', day: 'numeric'}
        } else if (this.format == 'full-date') {
            format = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }
        }
        this.innerHTML = this._dateObject.toLocaleString('en-GB', format);
    }
}

customElements.define('local-time', LocalTime);